'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var ONLINE = exports.ONLINE = 'online';
var OFFLINE = exports.OFFLINE = 'offline;';


//////////////////
// WEBPACK FOOTER
// ./js/usage-tracking/constants/widgetState.js
// module id = 764
// module chunks = 2 3